import axios, { AxiosInstance, AxiosResponse } from "axios";
import config from "@/utils/cognitoUrlConfig";

interface CognitoIdentity {
  name: string;
}

class QsDashboardService {
  client: AxiosInstance;

  constructor(jwt: string) {
    this.client = axios.create({
      baseURL: config.apiURL,
      withCredentials: false,
      headers: {
        Authorization: jwt,
      }
    });
  }
  async getDashboards(): Promise<AxiosResponse<CognitoIdentity>> {
    return await this.client.get("/qsdashboard");
  }
}

export default QsDashboardService;
